import moment from "moment";
import { RootState } from "redux/rootReducer";
import { UserPermission } from "types/UserPermission";
import { ActionType, getType } from "typesafe-actions";
import * as userActions from "./userActions";

export type UserState = {
  [K in userActions.UserContentType]?: {
    loading?: boolean;
    data?: userActions.UserDataType | UserPermission[];
    error?: string;
  };
} & {
  reportControlId?: string;
  reportDate?: string;
  startDate?: string;
};

export type UserActions = ActionType<typeof userActions>;

const initialState = {
  reportDate: moment.utc().subtract(1, "day").startOf("day").toISOString(),
  startDate: moment.utc().subtract(1, "month").startOf("month").toISOString(),
};

export const getReportDateSelector = (state: RootState) => state.user.reportDate;

export default function user(state: UserState = initialState, action: UserActions) {
  switch (action.type) {
    case getType(userActions.load):
      return {
        ...state,
        [action.contentType]: { ...state[action.contentType], loading: true },
      };
    case getType(userActions.loadSuccess):
      return {
        ...state,
        [action.contentType]: {
          ...state[action.contentType],
          loading: false,
          data: action.data,
          error: undefined,
        },
      };
    case getType(userActions.loadPermissionsSuccess):
      const reportControlIdExists =
        state.reportControlId &&
        (action.data as UserPermission[]).some(
          (up) => up.ReportControlId === state.reportControlId
        );
      return {
        ...state,
        reportControlId: reportControlIdExists
          ? state.reportControlId
          : ((action.data as UserPermission[]) ?? [])?.sort((a, b) =>
              a.Name.localeCompare(b.Name)
            )[0]?.ReportControlId,
        [action.contentType]: {
          ...state[action.contentType],
          loading: false,
          data: action.data,
          error: undefined,
        },
      };
    case getType(userActions.loadFail):
      return {
        ...state,
        [action.contentType]: {
          ...state[action.contentType],
          loading: false,
          error: action.error,
        },
      };
    case getType(userActions.selectUserPermission):
      return {
        ...state,
        reportControlId: action.permission,
      };
    case getType(userActions.changeReportDate):
      return {
        ...state,
        reportDate: action.reportDate,
      };
    case getType(userActions.changeStartDate):
      if (moment(state.reportDate).isBefore(moment(state.startDate))) {
        return {
          ...state,
          startDate: moment
            .utc(state.reportDate)
            .subtract(1, "months")
            .startOf("month")
            .toISOString(),
        };
      }
      return {
        ...state,
        startDate: action.startDate,
      };
    default:
      return state;
  }
}
